<template>
    <v-tab-item
        eager
    >
        <v-row>
            <v-col>
                <span class="text-body-1 font-weight-bold">{{ $t('chooseProblemsDrugTypes') }}</span>
            </v-col>
        </v-row>
        <category-item
            v-for="(item, idx) in Number(treatment.length)"
            :key="idx"
            :calculationIdx="calculationIdx"
            :treatmentIdx="treatmentIdx"
            :drugIdx="idx"
            :attributes="attributes"
            :categories="categories"
        ></category-item>
        <v-row
            justify="end"
        >
            <v-col cols="12" class="col-md-10">
                <div class="font-weight-medium text-right">{{ $t('budget') }} на 1 гектар для T{{ treatmentIdx }}: </div>
            </v-col>
            <v-col cols="12" class="col-md-2">
                <div class="font-weight-normal text-right text-md-left" v-if="summaryTabBudget !== 0">{{ formatBudget }} {{ currency.toUpperCase() }}</div>
            </v-col>
        </v-row>
        <v-divider></v-divider>
    </v-tab-item>
</template>

<script>
import CategoryItem from "./CategoryItem";
import numberFormat from "../../../../utils/numberFormat";
export default {
    name: "TreatmentTab",
    components: {
        CategoryItem
    },
    props: ['calculationIdx', 'treatmentIdx', 'attributes', 'categories'],
    computed: {
        currency() {
            return this.$store.getters.appCurrency;
        },
        summaryTabBudget() {
            let sum = 0;
            if(this.treatment.length > 0) {
                sum = this.treatment.reduce((accum, treatment) => {
                        const treatmentSum = treatment.budget ?  parseFloat(treatment.budget) : 0;
                        return accum + treatmentSum;
                }, sum)
            }
            return sum;
        },
        treatment() {
            return this.$store.getters.calculatorFullData[this.calculationIdx].treatments[this.treatmentIdx];
        },
        formatBudget() {
            return numberFormat(this.summaryTabBudget, 2, '.', ' ');
        },
    },
}
</script>

<style scoped>

</style>
